module.exports = __webpack_public_path__ + "static/media/drive-green.2856d954.svg";